import { getTenantHostSuffix, tenantSlugFromHostname } from './tenantHost';

/** Join-form deep link: `#platform-landing-join` and/or `?join=1` (Telegram keeps query better than hash). */
export const PLATFORM_LANDING_JOIN_ID = 'platform-landing-join';

export function isPlatformJoinDeepLink(
  search = typeof window !== 'undefined' ? window.location.search : '',
  hash = typeof window !== 'undefined' ? window.location.hash : '',
): boolean {
  const rawHash = String(hash || '').replace(/^#/, '').trim().toLowerCase();
  if (rawHash === PLATFORM_LANDING_JOIN_ID) return true;
  try {
    const join = new URLSearchParams(search).get('join');
    return join === '1' || join === 'true' || join === '';
  } catch {
    return false;
  }
}

/** Apex platform landing URL (manufacturer directory), not tenant storefront. */
export function platformLandingUrl(): string {
  if (typeof window === 'undefined') {
    return '/';
  }

  const slug = tenantSlugFromHostname();
  const suffix = getTenantHostSuffix();
  const { protocol, port } = window.location;

  if (slug && suffix) {
    return `${protocol}//${suffix}/`;
  }

  if (slug && window.location.hostname.endsWith('.localhost')) {
    const portPart = port ? `:${port}` : '';
    return `${protocol}//localhost${portPart}/`;
  }

  return '/';
}

/** Hide platform-home control when user is already on the apex platform landing. */
export function shouldShowPlatformHomeLink(
  pathname = typeof window !== 'undefined' ? window.location.pathname : '',
): boolean {
  if (!pathname) {
    return false;
  }
  if (pathname.startsWith('/platform')) {
    return false;
  }
  if (pathname !== '/') {
    return true;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    Boolean(tenantSlugFromHostname())
    || Boolean(new URLSearchParams(window.location.search).get('tenant'))
  );
}
